import React from 'react';
import DashboardStatusButton from 'components/atoms/DashboardStatusButton';
import { Link } from 'react-router-dom';
import { IIncidentMechanismSummary } from 'types/VehicleIncidents';
import { createCategoryAcronym } from 'utils/createCategoryAcronym';

export interface IDashboardIncidentMechanismBreakdownCard {
	className?: string;
	mechanisms: IIncidentMechanismSummary[] | undefined;
	incidentPath?: string;
	getExtraFilters?: () => { [key: string]: string | number };
}

const DashboardIncidentMechanismBreakdownCard: React.FC<
	IDashboardIncidentMechanismBreakdownCard
> = ({
	className = '',
	mechanisms,
	incidentPath,
	getExtraFilters = () => ({}),
}) => {
	var incident_total: JSX.Element | string = '';

	const extraFilters: { [key: string]: string | number } = {
		...getExtraFilters(),
	};

	//@ts-ignore
	const urlString = new URLSearchParams(extraFilters).toString();

	return (
		<table className={`${className} px-8 w-full`}>
			<thead className="border-b border-gray-200">
				<tr>
					<th className="text-secondary font-normal text-left pr-8 pb-3">
						Mechanism
					</th>
					<th className="text-secondary font-normal text-left pr-8 pb-3">
						Total
					</th>
					<th className="text-secondary font-normal text-left pr-8 pb-3">
						Status
					</th>
					<th className="text-secondary font-normal text-left pr-8 pb-3">
						Severity
					</th>
					<th className="text-secondary font-normal text-left pr-8 pb-3">
						Critical Action
					</th>
				</tr>
			</thead>
			<tbody>
				{mechanisms?.map((mechanism: IIncidentMechanismSummary) => {
					if (incidentPath === 'incidents') {
						incident_total = (
							<Link
								to={`/${incidentPath}?incidentMechanism=${mechanism.name}&${urlString}`}
							>
								{mechanism.statistics.total}
							</Link>
						);
					} else {
						incident_total = <>{mechanism.statistics.total}</>;
					}

					return (
						<tr
							className="border-b border-gray-200 py-4 font-normal font-scorpion-200"
							key={mechanism.id}
						>
							<td className="pr-8 py-5 font-inter text-scorpion-500">
								{createCategoryAcronym(mechanism.name)}
							</td>
							<td className="pr-8 py-5 underline font-inter text-scorpion-500">
								{incident_total}
							</td>
							<td>
								<div className="pr-8 flex flex-row flex-wrap gap-y-2 gap-x-2 py-3">
									{['new', 'draft', 'submitted', 'open', 'closed'].map(
										(status) => {
											// @ts-ignore trust me bro
											if (mechanism.statistics[status] === 0) {
												return null;
											}
											const extraLinkQuery = `incidentMechanism=${mechanism.name}&status=${status}&${urlString}`;
											return (
												<DashboardStatusButton
													key={`status-${mechanism.id}-${status}`}
													status={status}
													modulePath={incidentPath}
													// @ts-ignore trust me bro x2
													total={mechanism.statistics[status]}
													extraLinkQuery={extraLinkQuery}
													totalBrackets={true}
												/>
											);
										}
									)}
								</div>
							</td>
							<td>
								<div className="pr-8 flex flex-row flex-wrap gap-y-2 gap-x-2 py-3">
									{['Level 1', 'Level 2', 'Level 3', 'Level 4', 'Level 5'].map(
										(severity) => {
											// @ts-ignore trust me bro
											if (mechanism.statistics.severities[severity] === 0) {
												return null;
											}
											const extraLinkQuery = `incidentMechanism=${mechanism.name}&severity=${severity}&${urlString}`;
											// get number from end of severity string
											const severityNumber = severity.match(/\d+/);
											return (
												<DashboardStatusButton
													key={`severity-${mechanism.id}-${severity}`}
													status={severityNumber?.toString() || ''}
													modulePath={incidentPath}
													// @ts-ignore trust me bro x2
													total={mechanism.statistics.severities[severity]}
													extraLinkQuery={extraLinkQuery}
													totalBrackets={true}
												/>
											);
										}
									)}
								</div>
							</td>
							<td>
								<div className="pr-8 flex flex-row flex-wrap gap-y-2 gap-x-2 py-3">
									{mechanism.statistics.actions['open'] > 0 && (
										<DashboardStatusButton
											status="Open"
											modulePath={incidentPath}
											total={mechanism.statistics.actions['open']}
											extraLinkQuery={`incidentMechanism=${mechanism.name}&correctiveActions=open&${urlString}`}
											totalBrackets={true}
										/>
									)}
									{mechanism.statistics.actions['overdue'] > 0 && (
										<DashboardStatusButton
											status="Overdue"
											modulePath={incidentPath}
											total={mechanism.statistics.actions['overdue']}
											extraLinkQuery={`incidentMechanism=${mechanism.name}&correctiveActions=overdue&${urlString}`}
											totalBrackets={true}
										/>
									)}
									{mechanism.statistics.actions['completed'] > 0 && (
										<DashboardStatusButton
											status="Complete"
											modulePath={incidentPath}
											total={mechanism.statistics.actions['completed']}
											extraLinkQuery={`incidentMechanism=${mechanism.name}&correctiveActions=completed&${urlString}`}
											totalBrackets={true}
										/>
									)}
								</div>
							</td>
						</tr>
					);
				})}
			</tbody>
		</table>
	);
};

export default DashboardIncidentMechanismBreakdownCard;
